/**
 * Indicates whether the margin described is posted or received.
 * tag: 2851
 * @readonly
 * @enum {number} (int)
 */
export enum MarginDirection {
  Posted = 0,
  Received = 1,
}
